export default "icons/eye.svg"